export class Promo {
    code: string
    blurb: string
    captureCardBlurb: string
    emailRestrictions: string[]
    percentDiscount?: number
    fixedDiscountInPence?: number
    reflectOnQuotedPrice: boolean
}